import * as R from "ramda"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const capitalize = (input: any): string =>
  R.is(String, input)
    ? `${input.charAt(0).toLocaleUpperCase()}${input.substr(1).toLocaleLowerCase()}`
    : ""

export default capitalize
